import {EventKind, EventType} from 'services/analytics/const';
import {buildEventCreator, withoutOverrides} from 'services/analytics';

export const name = EventKind.AddSpend;
export const converter = withoutOverrides;
export const createEvent = buildEventCreator<EventType.Detailed, AddSpendEventPayload>({
  name,
  converter,
});
